import { render } from "./Recebimentos.vue?vue&type=template&id=5e925ff4&scoped=true"
import script from "./Recebimentos.vue?vue&type=script&lang=js"
export * from "./Recebimentos.vue?vue&type=script&lang=js"

import "./Recebimentos.vue?vue&type=style&index=0&id=5e925ff4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e925ff4"]])

export default __exports__